module.exports = " <div class=nav> <div class=main_page> <h1> <a href=index.html> <img src=" + require("../../assets/images/logo.png") + " />融聚智慧 | 创造价值</a> </h1> <ul class=nav_menu> <li class=\"\"><a href=javascript:; @click=\"markConsultant('eadvice')\">易咨询</a></li> <li><a href=javascript:;>亿学堂</a></li> <li><a href=javascript:;>顾问家</a></li> <li class=last><a href=javascript:;>企业俱乐部</a></li> </ul> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header-nav.vue
// module id = 226
// module chunks = 6 7 14 15 17 19